// app/(main)/politique-confidentialite/page.tsx

import { PageContainer } from "../../../components/ui/PageContainer";


export default function PrivacyPage() {
  return (
    <PageContainer withContainer >
      <div className="py-8 md:py-12 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
          Politique de confidentialité
        </h1>
        
        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Collecte des données</h2>
            <p>
              Nous collectons les informations que vous nous fournissez lors de votre inscription, 
              commande ou contact : nom, email, téléphone, adresse.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Utilisation des données</h2>
            <p>
              Vos données sont utilisées pour traiter vos commandes, vous contacter et améliorer 
              nos services. Nous ne vendons pas vos données à des tiers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Protection des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité pour protéger vos informations 
              contre tout accès non autorisé.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Cookies</h2>
            <p>
              Notre site utilise des cookies pour améliorer votre expérience de navigation 
              et analyser notre trafic.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Vos droits</h2>
            <p>
              Vous avez le droit d'accéder, modifier ou supprimer vos données personnelles. 
              Pour cela, contactez-nous à privacy@cabukaka.com.
            </p>
          </section>

          <div className="bg-gray-50 p-4 rounded-lg mt-8">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}